import React from 'react';
import { Box, Card, Container, Grid, Typography } from '@mui/material';

import { USER_LOAN_PROGRAM } from '@/config/constants';
import { HybridInterestRateDisplay } from '@/components/Common/HybridInterestRateDisplay';

export const HybridInterestRateTest = () => {
  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Hybrid Interest Rate System Test
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        This page demonstrates the hybrid interest rate system with backend
        caching and local adjustments.
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Conventional Loan
            </Typography>
            <HybridInterestRateDisplay
              loanProgram={USER_LOAN_PROGRAM.CONVENTIONAL}
              creditScore={750}
              ltv={80}
              showAdjustments={true}
            />
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              FHA Loan
            </Typography>
            <HybridInterestRateDisplay
              loanProgram={USER_LOAN_PROGRAM.FHA}
              creditScore={680}
              ltv={95}
              showAdjustments={true}
            />
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              VA Loan
            </Typography>
            <HybridInterestRateDisplay
              loanProgram={USER_LOAN_PROGRAM.VA}
              creditScore={720}
              ltv={90}
              showAdjustments={true}
            />
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              DSCR Loan
            </Typography>
            <HybridInterestRateDisplay
              loanProgram={USER_LOAN_PROGRAM.DSCR}
              creditScore={700}
              ltv={75}
              showAdjustments={true}
            />
          </Card>
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          How It Works
        </Typography>
        <Typography variant="body2" paragraph>
          1. <strong>Backend Rates</strong>: Fetched from admin panel, cached
          for 5 minutes
        </Typography>
        <Typography variant="body2" paragraph>
          2. <strong>Local Adjustments</strong>: Users can adjust rates locally
          without API calls
        </Typography>
        <Typography variant="body2" paragraph>
          3. <strong>Real-time Updates</strong>: Admin changes propagate to
          users within 5 minutes
        </Typography>
        <Typography variant="body2" paragraph>
          4. <strong>Instant Calculations</strong>: Loan estimates update
          immediately with cached rates
        </Typography>
      </Box>
    </Container>
  );
};
